module.exports = __webpack_public_path__ + "static/media/natalac.ade530b6.jpg";